import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../App.css';
import './PublicUpdateAgendamentoForm.css';
import logo from '../../assets/img/logo-header.png';
import agenda from '../../assets/icons/agenda.png';

import CadastrosInternosService from '../../services/CadastrosInternosService';
import EspecialidadesService from '../../services/EspecialidadesService';
import HorariosService from '../../services/HorariosService';
import AgendamentosService from '../../services/AgendamentosService';
import atualizarAgendamentoPublicDTO from "../../types/AgendamentoUpdatePublicDTO";

export default function PublicUpdateAgendamentoForm({ onClose, onSubmit }) {

  const [form, setForm] = useState({
    idCadastro: "",
    nome: "",
    data: "",
    idEspecialidade: "",
    tempo: "",
    idHorario: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [especialidades, setEspecialidades] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [blocosHorarios, setBlocosHorarios] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const hoje = new Date().toISOString().split("T")[0];

  const idCadastro = localStorage.getItem("UserId");

  useEffect(() => {
    async function carregarDados() {
      if (!idCadastro) return;

      try {
        const cliente = await CadastrosInternosService.getById(idCadastro);
        const esp = await EspecialidadesService.getLista();

        setForm(prev => ({
          ...prev,
          idCadastro,
          nome: cliente.NOME,
          data: hoje
        }));

        setEspecialidades(esp);

        const hist = await AgendamentosService.getAgendamentosAtivos(idCadastro);
        setHistorico(hist);

        await buscarHorarios(hoje);

      } catch (error) {
        console.error("Erro ao carregar dados iniciais:", error);
      }
    }

    carregarDados();
  }, [idCadastro]);

  async function buscarHorarios(dataSelecionada) {
    if (!dataSelecionada) return;

    try {
      const response = await HorariosService.getDisponiveis(dataSelecionada);
      setHorarios(response || []);
      atualizarBlocos(response, form.tempo);
    } catch (error) {
      console.error("Erro ao buscar horários:", error);
      setHorarios([]);
      setBlocosHorarios([]);
    }
  }

  function atualizarBlocos(horariosLista, tempoServico) {
    if (tempoServico > 60 && horariosLista && horariosLista.length > 0) {
      const blocos = montarHorariosEmBlocos(horariosLista, tempoServico);
      setBlocosHorarios(blocos);
    } else {
      setBlocosHorarios([]);
    }
  }

  function montarHorariosEmBlocos(horarios, tempoServicoEmMinutos) {
    if (!horarios || horarios.length === 0) return [];

    const blocos = [];
    const blocosNecessarios = Math.ceil(tempoServicoEmMinutos / 60);

    for (let i = 0; i < horarios.length; i++) {
      let valido = true;
      const bloco = [horarios[i]];

      for (let j = 1; j < blocosNecessarios; j++) {
        const atual = horarios[i + j];
        const anterior = horarios[i + j - 1];

        if (!atual) {
          valido = false;
          break;
        }

        const [h1, m1] = anterior.horario.split(":").map(Number);
        const [h2, m2] = atual.horario.split(":").map(Number);

        const diffMin = (h2 * 60 + m2) - (h1 * 60 + m1);

        if (diffMin !== 60) {
          valido = false;
          break;
        }

        bloco.push(atual);
      }

      if (valido) {
        blocos.push(bloco);
      }
    }

    return blocos;
  }

  function handleChange(e) {
    const { name, value } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === "data") {
      buscarHorarios(value);
      setForm(prev => ({ ...prev, idHorario: "" }));
    }

    if (name === "idEspecialidade") {
      const esp = especialidades.find(
        es => es.IDESPECIALIDADE === Number(value)
      );

      const tempo = esp?.tempo || "";

      setForm(prev => ({
        ...prev,
        tempo,
        idHorario: ""
      }));

      atualizarBlocos(horarios, tempo);
    }
  }

  function validarCampos() {
    const newErrors = {};
    if (!agendamentoSelecionado) newErrors.agendamento = "Selecione um agendamento para alterar";
    return newErrors;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const newErrors = validarCampos();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);

    try {
      const payload_update = atualizarAgendamentoPublicDTO({
        DATA: form.data,
        IDHORARIO: Number(form.idHorario) > 0
          ? Number(form.idHorario)
          : Number(agendamentoSelecionado.IDHORARIO),
        IDCADASTRO: Number(form.idCadastro),
        IDESPECIALIDADE: Number(form.idEspecialidade)
      });

      if (onSubmit) {
        await onSubmit({
          id: agendamentoSelecionado.IDAGENDAMENTO,
          payload: payload_update
        });
      }

    } catch (error) {
      console.error("Erro ao atualizar agendamento:", error);
    } finally {
      setLoading(false);
    }
    onClose();
  }

  async function handleSelectAgendamento(e) {
    const id = Number(e.target.value);
    if (!id) {
      setAgendamentoSelecionado(null);
      setForm(prev => ({
        ...prev,
        data: hoje,
        idEspecialidade: "",
        tempo: "",
        idHorario: ""
      }));
      setBlocosHorarios([]);
      setHorarios([]);
      return;
    }

    const ag = historico.find(a => a.IDAGENDAMENTO === id);
    setAgendamentoSelecionado(ag);

    const idEspecialidade = ag.IDESPECIALIDADE;
    const esp = especialidades.find(
      es => es.IDESPECIALIDADE === idEspecialidade
    );

    const tempo = esp?.tempo || "";

    setForm(prev => ({
      ...prev,
      data: ag.DATA,
      idEspecialidade,
      idHorario: ag.IDHORARIO,
      tempo
    }));

    try {
      const response = await HorariosService.getDisponiveis(ag.DATA);
      setHorarios(response || []);
      atualizarBlocos(response, tempo);
    } catch (error) {
      console.error("Erro ao buscar horários:", error);
      setHorarios([]);
      setBlocosHorarios([]);
    }
  }

  return (
    <div className="UpdateAgendamento-form-Container">
      <div className="UpdateAgendamento-form-Fechar" onClick={onClose}> X </div>

      <img src={logo} alt="Logotipo" className='UpdateAgendamento-form-logo'/>

      <div className="UpdateAgendamento-form-title">
        <img src={agenda} alt="agenda" className="icon"/>
        Agendamentos
      </div>
      <div className="UpdateAgendamento-form-linha"></div>

      <form onSubmit={handleSubmit}>
        <div className='UpdateAgendamento-form-alinhamento'>
          <label>Agendamento</label>
          <select
            value={agendamentoSelecionado?.IDAGENDAMENTO || ""}
            onChange={handleSelectAgendamento}
          >
            <option value="">Selecione um agendamento</option>
            {historico.map(ag => (
              <option key={ag.IDAGENDAMENTO} value={ag.IDAGENDAMENTO}>
                {ag.DATA} - {ag.HORARIO.slice(0,5)} - {ag.DESCRICAO}
              </option>
            ))}
          </select>
          {errors.agendamento && <span style={{ color: "red" }}>{errors.agendamento}</span>}
        </div>

        <div className='UpdateAgendamento-form-alinhamento'>
          <label>Nome:</label>
          <input name="nome" type="text" value={form.nome} disabled/>
        </div>

        <div className='UpdateAgendamento-form-alinhamento'>
          <label>Alterar a data?</label>
          <input name="data" type="date" min={hoje} className="date" value={form.data} onChange={handleChange}/>
          {errors.data && <span style={{ color: "red" }}>{errors.data}</span>}
        </div>

        <div className='UpdateAgendamento-form-alinhamento'>
          <label>Alterar o tipo de serviço?</label>
          <select name="idEspecialidade" value={form.idEspecialidade} onChange={handleChange}>
            <option value="">Selecione uma especialidade</option>
            {especialidades.map(esp => (
              <option key={esp.IDESPECIALIDADE} value={esp.IDESPECIALIDADE}>{esp.DESCRICAO}</option>
            ))}
          </select>
          {errors.especialidade && <span style={{ color: "red" }}>{errors.especialidade}</span>}
        </div>

        <div className='UpdateAgendamento-form-alinhamento'>
          <label>Alterar o horário?</label>
          <select name="idHorario" value={form.idHorario} onChange={handleChange} disabled={!form.data}>
            <option value="">
              {agendamentoSelecionado ? `Horário agendado: ${agendamentoSelecionado.HORARIO?.slice(0,5)}h` : "Selecione um horário"}
            </option>

            {form.tempo <= 60 ? (
              horarios.map(h => (
                <option key={h.idHorario} value={h.idHorario}>
                  {h.horario.slice(0, 5)} h
                </option>
              ))
            ) : (
              blocosHorarios.map((bloco, index) => (
                <option key={index} value={bloco[0].idHorario}>
                  {bloco.map(h => h.horario.slice(0, 5)).join(" e ")}
                </option>
              ))
            )}
          </select>
          {errors.horario && <span style={{ color: "red" }}>{errors.horario}</span>}
        </div>

        <div className="UpdateAgendamento-form-alinhamento-button">
          <button type="submit" disabled={loading} className="UpdateAgendamento-button">
            {loading ? "Enviando..." : "Atualizar"}
          </button>
          
          <button type="button" className="UpdateAgendamento-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}